
















































































// Incluimos los mensajes de este módulo

import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import GlobalMixin from "@/mixins/global";
import ModalViewPayment from "@/components/ModalPayment/ModalViewPayment.vue";
import TooltipBtn from "@/components/Tooltip/Tooltip.vue";
import moment from "moment";
import { concat, values } from "lodash";
import { toLower } from "lodash";
import dataTableContract from '@/components/DatatableContract/DatatableContractList.vue';
export default GlobalMixin.extend({
  //i18n: i18nMessages,
  props: ["search", "folFac", "order", "proveedor", "sociedad", "fecha"],
  components: {
    ModalViewPayment,
    TooltipBtn,
  },
  data: () => ({
    headerInvoiceList: [],
    headersRegistroPagos: [],
    items: [],
    invoices: [],
    DatatablePayments: [],
    dialog: false,
    moduleName: "DATATABLE_INVOICE",
    headerProps: {
      sortByText: "Ordenar por",
    },
    footerProps: {
      itemsPerPageText: "Registros por página",
      itemsPerPageAllText: "Todos",
      pageText: "{0}-{1} de {2}",
      sortByText: "Ordenar por",
    },
    loadingText: "Cargando... Por favor espere",
    noDataText: "Sin datos",
    loading: true,
    loadingPay: true,
    setItem: {},
    setIndex: -1,
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
    },
    settItem(item: Object) {
      this.setItem = Object.assign({}, item);
      this.DatatablePayments = [];
      (this.loadingPay = true), this.getPayment(item);

      this.dialog = true;
    },

    ini() {
      //Datatable de la lista de contrato
      (this.headerInvoiceList = [
        {
          text: "Folio factura",
          value: "folio",
          align: "start",
          filter: this.getfilterFolFac,
        },
        {
          text: "Proveedor",
          value: "proveedor",
          filter: this.getfilterProv,
        },
        {
          text: "Sociedad",
          value: "sociedad",
          filter: this.getfilterSoc,
        },
        {
          text: "Fecha factura",
          value: "fecha",
         // filter: this.getfilterRangeDate,
          formatter: this.dateFormatted,
          
        },
        {
          text: "No. Pedido",
          value: "numeroOC",
          filter: this.getfilterOrder,
        },
        {
          text: "No. Documento",
          value: "facturaIR",
        },
        {
          text: "Total",
          value: "total",
          formatter: this.money,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        },
      ]),
        //Obtiene la lista de contratos
        this.getInvoiceList();

      this.headersRegistroPagos = [
        {
          text: "Serie",
          align: "start",
          value: "serie",
        },
        {
          text: "Folio",
          value: "folio",
        },
        {
          text: "Documento SAP",
          value: "DocumentoSAP",
        },
        {
          text: "Ejercicio SAP",
          value: "EjercicioSAP",
        },
        {
          text: "Sociedad SAP",
          value: "SociedadSAP",
        },
        {
          text: "Fecha de pago",
          value: "FechaPago",
        },
        {
          text: "Importe pagado",
          value: "ImpPagado",
        },
        {
          text: "Archivo",
          value: "file",
        },
      ];
    },
    getfilterFolFac(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.folFac) {
        return true;
      }
      // Check if the current loop value
      // partially contains the searched word.
      return value.toLowerCase().includes(this.folFac.toLowerCase());
    },
    getfilterOrder(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.order) {
        return true;
      }
      let values = value.toString();
      return values.toLowerCase().includes(this.order.toLowerCase());
    },

    getfilterProv(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.proveedor) {
        return true;
      }
      let noProveedor = this.proveedor.userID;
      let values = value.toString();
      return values.toLowerCase().includes(noProveedor.toLowerCase());
    },

    getfilterSoc(value: any) {
      // If this filter has no value we just skip the entire filter.
      if (!this.sociedad) {
        return true;
      }
      let noSociedad = this.sociedad.empresaClave;
      let values = value.toString();
      return values.toLowerCase().includes(noSociedad.toLowerCase());
    },
    getfilterRangeDate(value: any){
      if(!this.fecha){
        return true;
      }

      let startDate = this.fecha[0];
      let endDate = this.fecha[1];
      if ( startDate >= value <= endDate ) {
        return value.toLowerCase().includes(value.toLowerCase())
      }
    },
    async getInvoiceList() {
      let isAuthorizerObra =
        this.$store.getters["auth/rol"] == "2" ? true : false;
      let isAdmin = ["4", "5"].includes(this.$store.getters["auth/rol"]) ? true : false;
      dataService
        .getAllInvoices()
        .then((Response: ResponseData) => {
          if (Response.data.data[0]) {
            Response.data.data[0].forEach((itemR: any) => {
              if (isAdmin) {
                this.items.push(itemR);
              } else {
                if (itemR.proveedorObra && isAuthorizerObra) {
                  this.items.push(itemR);
                } else if (!(itemR.proveedorObra && isAuthorizerObra)) {
                  this.items.push(itemR);
                }
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPayment(factura: any) {
      if (factura.serieF == "") {
        factura.serieF = "0";
      }

      dataService
        .getPaymentFolio(factura.serieF, factura.folioF)
        .then((Response: ResponseData) => {
          this.DatatablePayments = Response.data.data;
        })
        .catch((e: Error) => {})
        .finally(() => {
          this.loadingPay = false;
        });
    },
    // METODOS GENERICOS
    dateFormatted(value: string) {
      return moment
        .utc(value)
        .locale("es-mx")
        .format("L");
    },

    money(value: string) {
      let moneyS = "$ ";
      return moneyS + value;
    },
  },
  mounted() {
    this.ini();
  },
});
